"use client";

import { jsx } from "react/jsx-runtime";
import { BaseAutumnProvider } from "./BaseAutumnProvider";
import { AutumnClient } from "./client/ReactAutumnClient";
const ReactAutumnProvider = ({
  children,
  getBearerToken,
  backendUrl,
  customerData,
  includeCredentials = true
}) => {
  let client = new AutumnClient({
    backendUrl,
    getBearerToken,
    customerData,
    includeCredentials
  });
  return /* @__PURE__ */ jsx(BaseAutumnProvider, { client, children });
};
export {
  ReactAutumnProvider
};
